<template>
  <div>
    <div class="err-n">403</div>
    <div class="err-msg">
      <h2>{{ $t('Внимание') }}!</h2>
      <p>{{ $t('У Вас нет доступа к данной странице. Обратитесь к ответственному лицу по предоставлению разрешений. С уважением, администрация портала') }}.</p>
    </div>
  </div>
</template>

<script>
export default {
  name: "Error403"
}
</script>

<style scoped>

</style>
